import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QueryStatus, QueryWithExecutionRecord } from '../../../../../../API';
import { ValidationLogsViewModel } from '../../../../models/market-fan-exploration.model';
import { WorkbenchHistoryRecord, WorkbenchResultQueryRecord } from '../../../../models/history-model';
import { QueryHistoryService } from '../../../../services/query-history.service';

@Component({
  selector: 'app-workbench-view-modal',
  templateUrl: './workbench-view-modal.component.html',
  styleUrl: './workbench-view-modal.component.scss',
})
export class WorkbenchViewModalComponent {
  @Input() isVisible = false;
  @Input() isLoading = false;
  @Input() row: WorkbenchHistoryRecord | null = null;
  @Input() queryRecord: QueryWithExecutionRecord | null = null;
  @Input() queryText = '';
  @Output() close = new EventEmitter<void>();

  constructor(private readonly queryHistoryService: QueryHistoryService) {}

  get modalTitle(): string {
    return this.row ? `Details for Query Id: ${this.row.queryId}` : 'Query details';
  }

  get isWorkbenchSource(): boolean {
    return this.row?.querySource === 'Workbench';
  }

  get isSchedulerSource(): boolean {
    return this.row?.querySource === 'Scheduler';
  }

  get isExecutedQuery(): boolean {
    return this.row?.status === QueryStatus.EXECUTED;
  }

  get descriptionRowClass(): string {
    return this.isWorkbenchSource
      ? 'description-row description-row-full'
      : 'description-row description-row-scheduler';
  }

  get validationLogs(): ValidationLogsViewModel | null {
    const validationLogs = (this.queryRecord as (QueryWithExecutionRecord & { validationLogs?: string | null }) | null)
      ?.validationLogs;

    if (!validationLogs) {
      return null;
    }

    try {
      return JSON.parse(validationLogs) as ValidationLogsViewModel;
    } catch {
      return {
        errors: [''],
      };
    }
  }

  get validationSummaryType(): 'danger' | 'success' {
    return this.validationLogs?.errors?.length ? 'danger' : 'success';
  }

  get validationSummaryMessage(): string {
    return this.validationLogs?.message || '-';
  }

  get resultQueryRecord(): WorkbenchResultQueryRecord | null {
    const orgId = this.row?.orgId || this.queryRecord?.orgId || '';
    const queryId = this.row?.queryId || this.queryRecord?.queryId || '';
    const executionId = this.row?.executionId || this.queryRecord?.executionId || '';
    const athenaExecutionId = this.queryRecord?.athenaExecutionId || this.row?.athenaExecutionId || '';
    const metadata = this.queryRecord?.metadata || '{}';
    if (!orgId || !queryId || !executionId || !athenaExecutionId) {
      return null;
    }

    return {
      orgId,
      queryId,
      executionId,
      athenaExecutionId,
      metadata: metadata,
    };
  }

  getStatusColor(status: QueryStatus): string {
    return this.queryHistoryService.getStatusColor(status);
  }

  getDisplayStatus(status: QueryStatus): string {
    return this.queryHistoryService.getDisplayStatus(status);
  }

  onClose(): void {
    this.close.emit();
  }
}
